export default __webpack_public_path__ + "static/media/Leaders_IMG-Leader-03B.f89d9847.png";